import '../../../assets/css/catalogue_modal.css'
import '../../../assets/css/products_gallery.css'
import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

import TableCell from '@mui/material/TableCell';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import SearchIcon from '@mui/icons-material/Search';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import CloseIcon from '@mui/icons-material/Close';
import Tooltip from '@mui/material/Tooltip';
import Fab from '@mui/material/Fab';
import Button from '@mui/material/Button';
import DownloadIcon from '@mui/icons-material/Download';
import AddIcon from '@mui/icons-material/Add';
import UndoIcon from '@mui/icons-material/Undo';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Pagination from "react-js-pagination";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import empty from '../../empty.jpg'

import swal from 'sweetalert';
import { archive_product_by_service, get_all_products, get_categories_forAll_services, get_products_byCode, get_suppliers } from "../../../services/for_allServices";
import Loading_animation_view from "../../loading_animation_view/loading_animation_view";
import Add_product_modal from './add_product_modal/add_product_modal';
import Edit_product_modal from './add_product_modal/edit_product_modal';
import Import_products_modal from './import_products_modal/import_products_modal';


const columns = [
    { id: 'product_code', label: "Code produit", minWidth: 0 },
    { id: 'supplier', label: "Fournisseur", minWidth: 0 },
    { id: 'product_name', label: "Produit de référence", minWidth: 0 },
    { id: 'product_category', label: "Famille d'achat", minWidth: 0 },
    { id: 'product_price', label: "Prix", minWidth: 0 },
    { id: 'archived', label: "Archiver", minWidth: 0 },
];

function numberWithSpaces(x) {
    if (x) return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    else return x;
}


const Products_data = ({ product, id_product, get_category_name_by_id, get_supplier_by_id, view_product_details, handleDeleteClick }) => {

    return (
        <>
            <TableCell>
                <span style={{ textDecoration: "underLine", color: "blue", cursor: "pointer" }} onClick={() => view_product_details(product, id_product)}>
                    {product.product_code}
                </span>
            </TableCell>
            <TableCell>{product.id_supplier ? get_supplier_by_id(product.id_supplier) : "Aucun"}</TableCell>
            <TableCell> {product.title} </TableCell>
            <TableCell> {get_category_name_by_id(product.id_category)} </TableCell>
            <TableCell>{numberWithSpaces(product.product_price) + " MAD"}</TableCell>
            <TableCell>
                <Tooltip title="Archiver">
                    <DeleteForeverIcon style={{ color: 'red' }} onClick={() => handleDeleteClick({ product_reference: product.product_reference, product_code: product.product_code })} />
                </Tooltip>
            </TableCell>
        </>
    )
}


const Products_list = () => {
    let history = useHistory();
    const location = useLocation();

    const [suppliers, setsuppliers] = useState([]);
    const [categories, setCategories] = useState([]);

    const [products, setProducts] = useState(null);

    const [filter_categorie, setFilter_categorie] = useState("all");
    const [filter_supplier, setFilter_supplier] = useState("all");
    const [search_value, setsearch_value] = useState("");

    const [open_updateProduct_modal, setopen_updateProduct_modal] = useState(null);
    const [open_addProduct_modal, setOpen_addProduct_modal] = useState(false);
    const [list_updated_with_success, setList_updated_with_success] = useState(null);
    const [open_importProducts_to_catalogue_modal, setopen_importProducts_to_catalogue_modal] = useState(null);


    const [currentPage, setCurrentPage] = useState(1);
    const [dataPerPage, setdataPerPage] = useState(20);
    const [data_count, setdata_count] = useState(0);

    const [url_updated, setUrl_updated] = useState(null);
    const [waiting, setWaiting] = useState(false);

    useEffect(() => {
        async function load_data() {
            await get_suppliers().then((response) => {
               //  console.log("load_data : ", response.data);
                setsuppliers(response.data);
            }).catch((error) => {
               //  console.log(error.response);
            })
            await get_categories_forAll_services().then((response) => {
                setCategories(response.data);
            }).catch((error) => {
                //console.log(error.response);
            });
        }
        load_data();
    }, []);

    useEffect(() => {
        const load_data = async () => {
            setProducts(null);
            setdata_count(0);
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            var tmp_searchValue = "null";
            var tmp_filterSupplier = "all";
            var tmp_filterCategorie = "all";
            const page = urlParams.get('page') ? urlParams.get('page') : 1;
            if (urlParams.get('valeur')) {
                tmp_searchValue = urlParams.get('valeur');
            } if (urlParams.get('categorie')) {
                tmp_filterCategorie = urlParams.get('categorie');
            }
            if (urlParams.get('fournisseur')) {
                tmp_filterSupplier = urlParams.get('fournisseur');
            }
            await setFilter_supplier(tmp_filterSupplier);
            await setsearch_value(tmp_searchValue === "null" ? null : tmp_searchValue);
            await setFilter_categorie(tmp_filterCategorie);
            await setCurrentPage(page);
            const params = {
                filterCategory: tmp_filterCategorie,
                filterSupplier: tmp_filterSupplier,
                searchValue: tmp_searchValue,
                page: page
            };
            get_all_products(params).then((response) => {
                setProducts(response.data.data);
                setdata_count(response.data.total);
               //  console.log("==", response.data);
            }).catch((error) => {
               //  console.log(error.response);
            });
        }
        load_data();

    }, [url_updated, list_updated_with_success]);


    function get_category_name_by_id(id_category) {
        let tmp_name = "";
        for (let category of categories) {
            if (category.id_category == parseInt(id_category)) tmp_name = category.name;
        }
        return tmp_name;
    }


    function get_supplier_by_id(id) {
        // //  console.log("suppli")
        let tmp_supplier = "";
        for (let supplier of suppliers) {
            if (supplier.id == id) { tmp_supplier = supplier.parentCompany; break; }
        }
        return tmp_supplier;
    }

    function archive_product(product_code, archive, id) {
        swal({
            title: "Etes-vous sûr ?",
            text: archive == 1 ? "Une fois archivé, le produit n'est plus accessible aux demandeurs !" : "!!!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    setWaiting(true);
                    let formData = new FormData();
                    formData.append("product_code", product_code);
                    formData.append("archive", archive);
                    archive_product_by_service(formData).then((response) => {
                       //  console.log("archive", response.data);
                        let tmp_products = [...products];
                        tmp_products[id].archived = archive;
                        setProducts(tmp_products);
                        //setList_updated_with_success(response.data);
                        setWaiting(false);
                    }).catch((error) => {
                       //  console.log(error.response);
                        setWaiting(false);
                    });
                }
            })
    }

    const handleClose_addProduct = () => {
        setOpen_addProduct_modal(false);
    };


    async function open_update_modal(product_code) {
        setWaiting(true);
        let formData = new FormData();
        formData.append('products_codes', JSON.stringify([product_code]));
        await get_products_byCode(formData).then((response) => {
           //  console.log(response.data);
            for (let key in response.data) {
                setopen_updateProduct_modal(response.data[key].products[0]);
            }
            setWaiting(false);
        }).catch((error) => {
            //console.log(error.response);
            setWaiting(false);
        });
    }


    function view_details(product_code) {
        const serviceRoot = location.pathname.split('/')[1];
        history.push(`/${serviceRoot}/produit/${product_code}`);
    }


    function search() {
        let path = history.location.pathname;
        const urlParams = new URLSearchParams(window.location.search);

       //  console.log(search_value);
        if (search_value && search_value.trim() !== "") {
            urlParams.set("valeur", search_value);
        } else {
            urlParams.delete("valeur");
        }

        history.push(`${path}?${urlParams.toString()}`);
        setUrl_updated(search_value);
    }

    function reset_search() {
        let path = history.location.pathname;
        history.push(path);
        setFilter_categorie("all");
        setFilter_supplier("all");
        setsearch_value("");
        setUrl_updated("reset");
    }

    function set__categorie(value) {
        let path = history.location.pathname;
        if (value !== "all") history.push(path + "?categorie=" + value);
        else history.push(path + "?categorie=all");
        setUrl_updated(value);
    }

    function set__supplier(value) {
        let path = history.location.pathname;
        const urlParams = new URLSearchParams(window.location.search);

       //  console.log(value);
        if (value) {
            urlParams.set("fournisseur", value);
        } else {
            urlParams.delete("fournisseur");
        }

        history.push(`${path}?${urlParams.toString()}`);
        setFilter_supplier(value);
        setUrl_updated(value);
    }


    async function change_page(page) {
        setCurrentPage(page); // Mise à jour de la page
        let path = history.location.pathname;
        let params = history.location.search;
        let search_params = params.split('&');
        let tmp_params = path;

        if (!params) {
            history.push(path + "?page=" + page);
        } else {
            for (let i in search_params) {
                if (search_params[i].includes("page=")) {
                    search_params[i] = "page=" + page;
                }
            }
            tmp_params = path + "?" + search_params.join('&');
            if (!tmp_params.includes("page=")) {
                tmp_params += "&page=" + page;
            }
            history.push(tmp_params);
        }
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            search();
        }
    };

    function get_supplier_currency_by_id(suppliers, id_supplier) {
        const supplier = suppliers.find(
            (s) => s.id === id_supplier
        );
        return supplier?.currency_code || null;
    }


    return (
        <>
            {
                products == null
                    ? <Loading_animation_view />
                    : <div className='products_gallery_modal_container supplier_page'>
                        <div className="products_gallery_header_container">
                            <div style={{ marginRight: '7px', display: 'flex' }}>
                                <Tooltip title="Ajouter">
                                    <Fab className="add_new_object_fab add_new_object_fab_big" onClick={() => setOpen_addProduct_modal(true)} >
                                        <AddIcon className="my_icon" />
                                    </Fab>
                                </Tooltip>

                                <Tooltip title="Importer">
                                    <Fab className="add_new_object_fab add_new_object_fab_big" onClick={() => setopen_importProducts_to_catalogue_modal(true)}>
                                        <DownloadIcon className="my_icon" />
                                    </Fab>
                                </Tooltip>
                            </div>
                            <div className='search_filter_container'>
                                <FormControl variant="standard" className="header_form" >
                                    <InputLabel id="demo-simple-select-helper-label">Famille d'achat</InputLabel>
                                    <Select required value={filter_categorie}
                                        onChange={e => { set__categorie(e.target.value) }} >

                                        <MenuItem value={"all"}>Tous</MenuItem>
                                        {
                                            categories.map((categorie, id) => (
                                                <MenuItem value={categorie.id_category} key={id} >{categorie.name}</MenuItem>
                                            ))
                                        }

                                    </Select>
                                </FormControl>
                                <FormControl variant="standard" className={suppliers.length === 0 ? "header_form disabled_button" : "header_form"} >
                                    <InputLabel id="demo-simple-select-helper-label">Maison mère -- Fournisseur</InputLabel>
                                    <Select required value={filter_supplier}
                                        onChange={e => { set__supplier(e.target.value) }} >

                                        <MenuItem value={"all"}>Tous</MenuItem>
                                        {
                                            suppliers.map((supplier, id) => (
                                                <MenuItem value={supplier.id} key={id} >{supplier.parentCompany + " -- " + supplier.fullName}</MenuItem>
                                            ))
                                        }

                                    </Select>
                                </FormControl>
                                <Grid container spacing={1} alignItems="flex-start" className="search_bar">
                                    <Grid item>
                                        <SearchIcon onClick={search} className={search_value === "" ? "my_icon disabled_button" : "my_icon"} style={{ cursor: "pointer" }} />
                                    </Grid>
                                    <Grid>
                                        <TextField variant='standard' label="Chercher" className={filter_supplier === "null" ? "disabled_button" : ""} value={search_value} onKeyDown={handleKeyDown} onChange={(e) => { setsearch_value(e.target.value) }} />
                                    </Grid>
                                    <Grid item style={{ marginLeft: "5px" }}>
                                        <CloseIcon onClick={reset_search} className={search_value === "" ? "my_icon disabled_button" : "my_icon"} style={{ cursor: "pointer" }} />
                                    </Grid>
                                </Grid>
                            </div>
                        </div>
                        <div className="products_gallery_modal_contents_container products_gallery_contents_container">
                            {
                                products.length !== 0
                                    ? <>
                                        <div className="products_contents_container">
                                            {
                                                products.map((val, id) => {
                                                    return (
                                                        <React.Fragment key={id}>
                                                            <div className="main_card_container">
                                                                <div className="main_card_img_container">
                                                                    <img src={val.product_pic !== "" ? `data:image/png;base64,${val.product_pic}` : empty} />
                                                                </div>
                                                                <div className="main_card_infos_container">
                                                                    <div className="card_title">{val.title}</div>
                                                                    <div className="card_description">{val.description}</div>
                                                                    <div className="card_title">{numberWithSpaces(val.product_price) + " " + get_supplier_currency_by_id(suppliers, val.id_supplier)}</div>
                                                                    <div className={val.archived == 1 ? "view_more_button_container archived_product" : "view_more_button_container"}>
                                                                        <div>
                                                                            <Button variant="contained" className="submit_but edit_but" onClick={() => { view_details(val.product_code) }} >
                                                                                {val.archived == 1 ? "Plus de détails (Archivé)" : "Plus de détails"}
                                                                            </Button>
                                                                        </div>
                                                                        <div className="update_buttons">
                                                                            {
                                                                                val.archived == 1
                                                                                    ? <Tooltip title="Restaurer">
                                                                                        <Fab className="success_object_fab" onClick={() => { archive_product(val.product_code, 0, id) }} >
                                                                                            <UndoIcon className="my_icon" />
                                                                                        </Fab>
                                                                                    </Tooltip>
                                                                                    : <Tooltip title="Archiver">
                                                                                        <Fab className="cancel_object_fab" onClick={() => { archive_product(val.product_code, 1, id) }} >
                                                                                            <DeleteIcon className="my_icon" />
                                                                                        </Fab>
                                                                                    </Tooltip>
                                                                            }
                                                                            <Tooltip title="Modifier">
                                                                                <Fab className="success_object_fab" onClick={() => open_update_modal(val.product_code)}>
                                                                                    <EditIcon className="my_icon" />
                                                                                </Fab>
                                                                            </Tooltip>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </React.Fragment>

                                                    );
                                                })
                                            }
                                        </div>
                                        <div className="pagination_container">
                                            <Pagination
                                                activePage={Number(currentPage)}
                                                itemsCountPerPage={dataPerPage}
                                                totalItemsCount={Number(data_count)}
                                                pageRangeDisplayed={4}
                                                onChange={change_page.bind(this)}
                                            />
                                        </div>
                                    </> : filter_categorie !== "all"
                                        ? <div className='emptytable_msg_container'>Aucun produit disponible</div>
                                        : <div className='emptytable_msg_container'>Sélectionner votre Famille d'achat</div>
                            }
                        </div>
                    </div>
            }
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={waiting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            {
                open_addProduct_modal == true
                    ? <Add_product_modal categories={categories} suppliers={suppliers} open_addProduct_modal={open_addProduct_modal}
                        handleClose_addProduct={handleClose_addProduct} setList_updated_with_success={setList_updated_with_success} setProducts={setProducts} />
                    : <></>
            }
            {
                open_updateProduct_modal !== null
                    ? <Edit_product_modal categories={categories} suppliers={suppliers} open_updateProduct_modal={open_updateProduct_modal}
                        setOpen_updateProduct_modal={setopen_updateProduct_modal} setList_updated_with_success={setList_updated_with_success} setProducts={setProducts} />
                    : <></>
            }
            {
                open_importProducts_to_catalogue_modal !== null
                    ? <Import_products_modal categories={categories} suppliers={suppliers} setList_updated_with_success={setList_updated_with_success}
                        open_importProducts_to_catalogue_modal={open_importProducts_to_catalogue_modal} setopen_importProducts_to_catalogue_modal={setopen_importProducts_to_catalogue_modal} />
                    : <></>
            }
        </>
    );
}

export default Products_list;